/**
 * Get playlist items from brightspot
 *
 */
import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

const SEARCH_PAGE_ID = '/dosearch'
export const myPlaylistGQLQuery = (contentIds) => {
  const imageSize = getIsLowBandwidth() ? 250 : 500
  return gql(`
    query Pagination ($page: Int = 1) {
      RootsTechSearchPage(contentIds: ${JSON.stringify(contentIds)}, page: $page, id:"${SEARCH_PAGE_ID}") {
        nextPage
        title
        results {
          date{
            timestamp
          }
          parentLocale
          locale
          objectTypeId
          url
          type
          title
          category
          description
          contentUUID
          image {
            custom(height: ${imageSize}, width: ${imageSize}) {
              image {
                src
              }
            }
          }
          creators {
            name
            profilePhoto {
              custom(height: ${imageSize}, width: ${imageSize}) {
                image {
                  src
                }
              }
            }
          }
        }
      }
    }
  `)
}

export const dummy = () => {}
